/** Parse les dates GraphQL / Prisma (ISO, timestamps ms ou s en nombre ou chaîne). */
export function parseFlexibleDate(
  value: string | number | Date | null | undefined
): Date {
  if (value == null) return new Date(NaN);
  if (value instanceof Date) return value;
  if (typeof value === 'number') {
    return new Date(value > 1e12 ? value : value * 1000);
  }
  const s = String(value).trim();
  if (/^\d+$/.test(s)) {
    const n = Number(s);
    if (Number.isNaN(n)) return new Date(NaN);
    return new Date(n > 1e12 ? n : n * 1000);
  }
  return new Date(s);
}
